import { isVisible } from "../utils";

// styles
import '../../scss/widgets/resorts-carousel.scss';


;( function () {
    window.addEventListener("elementor/frontend/init", function () {
        elementorFrontend.hooks.addAction("frontend/element_ready/ikos-carousel.default", function ($scope) {
            boom( $scope[0] )
        })
		elementorFrontend.hooks.addAction("frontend/element_ready/ikos-destination-carousel.default", function ($scope) {
            boom( $scope[0] )
        })
    })
}) ()

function boom( element ) {
    element.querySelectorAll('.ikos-carousel').forEach( carousel => {
        initSlider( carousel )
    }  )
}

function initSlider( carousel ) {

    if ( ! window.ikosSwiper ) {
        console.warn( 'window.ikosSwiper: dependency not found' );
    }

    if ( ! window.ikosGsap ) {
        console.warn( 'window.ikosGsap: dependency not found' );
    }

    const { Swiper, Navigation, Pagination } = window.ikosSwiper
    const gsap = window.ikosGsap;

    const dummy = carousel.querySelector('.ikos-dummy-container');

    let config = carousel.getAttribute('data-config');

    if ( config ) {
        config = JSON.parse( config );
    }

    const scrollAnim = config['scrollAnimation'];
    const slideAnim = config['slideAnimation'];

    const isEditorMode = document.querySelector('.elementor-edit-mode')


    const SPEED = 500;
    const TRANSLATE = {
        stagger: 0.1,
        duration: SPEED / 1000,
        ease: 'power1.out'
    }

    const OPACITY = {
        opacity: 0,
        duration: 0.1,
        ease: 'power1.out'
    }

    let lastTranslate = 0;
    let timeline;
    let firstTranslate = true;

    let animationOptions = {}

    if ( ! isEditorMode && slideAnim ) {
        animationOptions = {
            virtualTranslate: true,
            watchSlidesProgress: true,
        }
    }

    function getDesktopOffset(  ) {

        const _offset = config['offsetOptions'];

        const container = dummy.getBoundingClientRect().x

        switch ( _offset ) {
            case "container":
                return container;
            case "fixed":
                return 120;
            case "container_fixed":
                return container + 120;
            default:
                return 0;
        }
    }

    const desktopOffset = getDesktopOffset();

    new Swiper( carousel, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 32,
        slidesOffsetAfter: 32,
        modules: [Navigation, Pagination],
        speed: SPEED,
        ...animationOptions,
        pagination: {
            el: carousel.querySelector('.slider-pagination'),
            clickable: true
        },
        navigation: {
            nextEl: carousel.querySelector('.slider-button-next button'),
            prevEl: carousel.querySelector('.slider-button-prev button'),
        },
        breakpoints: {
            576: {
                spaceBetween: 20,
            },
            768: {
                slidesPerView: config['slidesPerView'],
                spaceBetween: typeof config['spaceBetween'] === "number" ? config['spaceBetween'] :  20,
                allowTouchMove: false,
                slidesOffsetAfter: 0,
            },
            1024: {
                slidesPerView: config['slidesPerView'],
                spaceBetween: typeof config['spaceBetween'] === "number" ? config['spaceBetween'] :  20,
                slidesOffsetBefore: desktopOffset,
                slidesOffsetAfter: 0,
            }
        },
        on: {
            afterInit: function ( _swiper ) {
                if ( isEditorMode || ! scrollAnim ) return;
                let slides = _swiper.el.querySelectorAll('.swiper-slide-visible .ikos-carousel-item-inner');
                slides = gsap.utils.toArray( slides );
                const images = slides.map( ( slide )  => slide.querySelector('.ikos-carousel-image'));
                const contents = slides.map( slide => slide.querySelector('.ikos-carousel-content') );

                timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: _swiper.el,
                        start: "top 85%",
                        end: "top 50%",
                        markers: false,
                        once: true
                    },
                    defaults: {
                        duration: 0.8,
                        ease: "power1.inOut",
                        stagger: {
                            each: 0.1,
                            from: "center"
                        }
                    }
                });
                timeline.fromTo(
                    images,
                    {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
                        visibility: 'hidden',
                    },
                    {
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        visibility: 'visible',
                    }
                )
                timeline.from( contents, {
                    delay: 0.8,
                    duration: 0.7,
                    autoAlpha: 0,
                    ease: "power1.inOut",
                    y: 50
                }, "<" )
                // timeline.fromTo( slides, OPACITY, { ...OPACITY, opacity: 1 }, "<" )
            },
            setTranslate: function ( _swiper, translate) {

                if ( isEditorMode || ! slideAnim ) return;

                const isSwiping = Math.abs( lastTranslate - translate ) + 20 < _swiper.slides[0]?.swiperSlideSize;
                const noAnimation = firstTranslate && isSwiping;
                firstTranslate = false;

                const forward = translate < lastTranslate;
                lastTranslate = translate;
                const options = {
                    ...TRANSLATE,
                    x: translate,
                    stagger: {
                        each: TRANSLATE.stagger,
                        from: forward ? 'start' : 'end',
                    }
                };

                if ( isSwiping ) {
                    delete options['stagger'];
                }

                if ( noAnimation ) {
                    options.duration = 0;
                }

                gsap.to( _swiper.slides,{
                    ...TRANSLATE,
                    ...options,
                });
            }
        }
    } )

}


